import React from 'react'

function NavMessage() {
  // return (
  //   <li className='nav-item dropdown'>
  //       <a href="#" className='nav-link-icon' data-bs-toggle='dropdown'>
  //           <i className='bi bi-bell'></i>
  //           <span className='badge bg-primary badge-number'>4</span>

  //       </a>

  //       <ul className='dropdown-menu dropdown-menu-end dropdown-menu-arrow notifications'>
  //           <li className='dropdown-header'>
  //           You Have 4 new Messages
  //           <a href="#"></a>
  //           <span className='badge rounded-pill bg-primary p-2 ms-2'>View all</span>
  //           </li>
  //           <li>
  //             <hr className='dropdown-divider' />  
  //           </li>

  //           <li className='message-item'>
  //               <a href='#'></a>
  //               <img src="assets/img" alt="" className='rounded-circle'/>
  //               <div>
  //                   <h4>Bright</h4>
  //                   <p>Having issue with the printer</p>
  //                   <p>10min. ago</p>
  //               </div>

  //           </li>
  //           <li>
  //             <hr className='dropdown-divider' />  
  //           </li>

  //           <li className='message-item'>
  //               <a href='#'></a>
  //               <img src="assets/img" alt="" className='rounded-circle'/>
  //               <div>
  //                   <h4>Bright</h4>
  //                   <p>Having issue with the printer</p>
  //                   <p>10min. ago</p>
  //               </div>

  //           </li>

  //           <li>
  //             <hr className='dropdown-divider' />  
  //           </li>

  //           <li className='message-item'>
  //               <a href='#'></a>
  //               <img src="assets/img" alt="" className='rounded-circle'/>
  //               <div>
  //                   <h4>Bright</h4>
  //                   <p>Having issue with the printer</p>
  //                   <p>10min. ago</p>
  //               </div>

  //           </li>

  //           <li>
  //             <hr className='dropdown-divider' />  
  //           </li>

  //           <li className='message-item'>
  //               <a href='#'></a>
  //               <img src="assets/img" alt="" className='rounded-circle'/>
  //               <div>
  //                   <h4>Bright</h4>
  //                   <p>Having issue with the printer</p>
  //                   <p>10min. ago</p>
  //               </div>

  //           </li>
  //           <li>
  //             <hr className='dropdown-divider' />  
  //           </li>

  //           <li className='dropdown-footer'>
  //             <a href='#'>Show all messages</a>  
  //           </li>

  //       </ul>

  //   </li>
  // )
}

export default NavMessage